import {
  Menu, MenuButton, MenuItem, MenuItems,
  Transition,
} from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import React from 'react';

interface DropdownProps {
  dropdownActivated: boolean;
  options: { id: number; name: string }[];
  selectedOption: { id: number; name: string };
  onOptionSelect: (option: { id: number; name: string }) => void;
  setSearchQuery?: (query: string) => void;
}

const truncate = (input: string | undefined, maxLength: number) => {
  if (!input) {return '';}
  return input.length > maxLength ? `${input.substring(0, maxLength)}...` : input;
};

const CompanyDropdown: React.FC<DropdownProps> = ({
  dropdownActivated, options, selectedOption, onOptionSelect, setSearchQuery,
}) => {
  if (!selectedOption?.name) {
    return null;
  }

  const truncatedName = truncate(selectedOption.name, 18);

  return (
    <div className="inline-block">
      {dropdownActivated ? (
        <Menu as="div" className="inline-block">
          <div className="flex items-center">
            <span className="mr-2 block lg:hidden">{truncatedName}</span>
            <span className="mr-2 hidden lg:block">{selectedOption.name}</span>
            <MenuButton className="flex items-center rounded">
              <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </MenuButton>
          </div>
          <Transition
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <MenuItems className="absolute right-0 z-[1000] mt-2 max-h-60 w-64 overflow-auto rounded-xl bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
              <div className="p-2" onClick={(e) => e.stopPropagation()}>
                <input
                  type="text"
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                  placeholder="Rechercher..."
                  className="w-full rounded-xl border px-2 py-1 text-sm text-gray-700 focus:border-blue-500 focus:outline-none"
                  autoComplete="nope"
                />
              </div>
              {options.map((option) => (
                <MenuItem key={option.id}>
                  <button
                    onClick={() => {
                      setSearchQuery('');
                      onOptionSelect(option);
                    }}
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                  >
                    {option.name}
                  </button>
                </MenuItem>
              ))}
            </MenuItems>
          </Transition>
        </Menu>
      ) : (
        <div className="flex items-center rounded">
          <span className="mr-2 block lg:hidden">{truncatedName}</span>
          <span className="mr-2 hidden lg:block">{selectedOption.name}</span>
        </div>
      )}
    </div>
  );
};

export default CompanyDropdown;
